import React, { useCallback, useEffect, useState } from 'react'
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { placeholderLogoModule } from '../../../../../../modules/placeholderLogo'
import getSnapshotData from '../../../../../../services/micro/get_snapshot_data'
import PreviewLoader from './PreviewLoader'

const REVIEW_STATUS = 3
const DRAFT_STATUS = 4
const LIVE_STATUS = 1
const REJECTED_STATUS = 2

const tabsConfig = {
  current: {
    key: 'current',
    title: 'Current Auction',
    disabled: false
  },
  previous: {
    key: 'previous',
    title: 'Previous Auction',
    disabled: true
  }
}

function IntervalAuctionPreview({
  isHTR,
  inventoryCampaign,
  estimatedPosition,
  campaign,
  currentSkin,
  publisherIdByAbbr,
  translatedPpcModalTooltips,
  ppc_modal_labels,
  language,
  getConsistentWidth,
  render_status_labels,
  estimateIsLoading,
  inventoryId
}) {
  const [tabs, setTabs] = useState([])
  const [tabKey, setTabKey] = useState('current')
  const [data, setData] = useState(null)
  const [snapshotData, setSnapshotData] = useState([])

  useEffect(() => {
    if (inventoryCampaign?.id) {
      getSnapshotData(inventoryCampaign?.id, inventoryId)
        .then(res => {
          setSnapshotData(res?.data)
        })
        .catch(err => {
          console.log('err:', err)
          setSnapshotData([])
        })
    }
  }, [inventoryCampaign, inventoryId])

  useEffect(() => {
    if (tabKey === 'current' && estimatedPosition?.inventory_campaigns.length > 0) {
      setData(estimatedPosition?.inventory_campaigns)
    } else if (tabKey === 'previous' && snapshotData.length > 0) {
      setData([...snapshotData])
    }
  }, [tabKey, estimatedPosition, snapshotData])

  const getTabs = useCallback(() => {
    if (!inventoryCampaign?.inventory?.recurring_interval) {
      return [tabsConfig.current]
    }

    return Object.keys(tabsConfig).map(key => {
      if (key === 'previous') {
        const hasSnapshotData = snapshotData && snapshotData.length > 0
        return {
          ...tabsConfig[key],
          disabled: !hasSnapshotData
        }
      }
      return tabsConfig[key]
    })
  }, [snapshotData, inventoryCampaign])

  useEffect(() => {
    setTabs(getTabs())
  }, [getTabs])

  return (
    <div>
      <Nav className="nav-line mb-4">
        {tabs.map(tab => (
          <Nav.Link key={tab.key} onClick={() => setTabKey(tab.key)} className={tabKey === tab.key ? 'active' : ''} disabled={tab.disabled}>
            {tab.title}
          </Nav.Link>
        ))}
      </Nav>

      {estimateIsLoading || !estimatedPosition || !data || (data && data.length === 0) ? (
        <div className="text-center">
          <ol className="vendor-list">
            <PreviewLoader length={inventoryCampaign?.vendors?.length || (isHTR ? 10 : 6)} getConsistentWidth={getConsistentWidth} />
          </ol>
        </div>
      ) : (
        <ol className="vendor-list">
          {data?.map((item, index) => (
            <li key={index} data-position={item.position} className={item.id === inventoryCampaign?.id ? 'vendor current' : 'vendor'}>
              <div className="d-sm-flex align-items-center">
                <div className="avatar avatar-xs" style={{ minWidth: 20 }}>
                  {item.id === inventoryCampaign?.id ? (
                    campaign?.logo_file ? (
                      <img src={campaign?.logo_file} alt="logo" className="avatar-img" />
                    ) : (
                      placeholderLogoModule(publisherIdByAbbr, currentSkin, item.logo)
                    )
                  ) : (
                    <div className="avatar-img" />
                  )}
                </div>
                <span className="ms-2 fs-sm">
                  {item.id === inventoryCampaign?.id ? <strong>{item.inventory_name}</strong> : <span>{item.inventory_name}</span>}
                  {item.id === inventoryCampaign?.id && inventoryCampaign.inventory_campaign_status === REVIEW_STATUS ? (
                    <OverlayTrigger placement="bottom" overlay={<Tooltip placement="bottom">{translatedPpcModalTooltips.under_review}</Tooltip>}>
                      <span className="badge bg-outline-warning ms-2">{ppc_modal_labels[language]['Under Review']}</span>
                    </OverlayTrigger>
                  ) : (
                    <></>
                  )}
                  {item.id === inventoryCampaign?.id && inventoryCampaign.inventory_campaign_status === DRAFT_STATUS ? (
                    <OverlayTrigger placement="bottom" overlay={<Tooltip placement="bottom">{translatedPpcModalTooltips.draft}</Tooltip>}>
                      <span className="badge bg-outline-secondary ms-2">{ppc_modal_labels[language].draft}</span>
                    </OverlayTrigger>
                  ) : (
                    <></>
                  )}
                  {item.id === inventoryCampaign?.id && inventoryCampaign.inventory_campaign_status === LIVE_STATUS ? (
                    <OverlayTrigger placement="bottom" overlay={<Tooltip placement="bottom">{translatedPpcModalTooltips.approved}</Tooltip>}>
                      <span className="badge bg-outline-success badge-approved ms-2">{render_status_labels[language].Approved}</span>
                    </OverlayTrigger>
                  ) : (
                    <></>
                  )}
                  {item.id === inventoryCampaign?.id && inventoryCampaign.inventory_campaign_status === REJECTED_STATUS ? (
                    <span className="badge bg-outline-danger ms-2">Rejected</span>
                  ) : (
                    <></>
                  )}
                </span>
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  )
}

export default IntervalAuctionPreview
